/** Pattern for Angular `pattern` validator on LinkedIn profile/company URLs. */
export const LINKEDIN_URL_PATTERN =
  '^(https?:\\/\\/)?(www\\.)?linkedin\\.com\\/(in|company)\\/[a-zA-Z0-9\\-_%]+\\/?$';

export const LINKEDIN_URL_VALIDATION_MESSAGE =
  'Enter a valid LinkedIn profile or company URL';

const LINKEDIN_URL_REGEX = new RegExp(LINKEDIN_URL_PATTERN);
const EMAIL_PATTERN = '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$';

function normKey(value: string): string {
  return (value || '').toLowerCase().replace(/[\s_-]+/g, '');
}

export function isLinkedInLinkField(field: {
  field_name?: string;
  label?: string;
}): boolean {
  const combined = normKey(
    `${field?.field_name || ''}${field?.label || ''}`
  );
  return combined.includes('linkedin') && combined.includes('link');
}

export function isValidLinkedInUrl(value: string): boolean {
  const trimmed = (value || '').trim();
  if (!trimmed) {
    return true;
  }
  return LINKEDIN_URL_REGEX.test(trimmed);
}

export function getLeadFieldPattern(item: {
  type?: string;
  field_name?: string;
  label?: string;
}): string {
  if (item?.type === 'email') {
    return EMAIL_PATTERN;
  }
  if (isLinkedInLinkField(item)) {
    return LINKEDIN_URL_PATTERN;
  }
  return '.*';
}

export function validateLeadLinkedInFields(
  fields: Array<{ field_name?: string; label?: string }>,
  values: Record<string, unknown> | null | undefined
): { valid: boolean; label?: string } {
  for (const item of fields || []) {
    if (!isLinkedInLinkField(item) || !item.field_name) {
      continue;
    }
    const value = values?.[item.field_name];
    if (
      value != null &&
      String(value).trim() !== '' &&
      !isValidLinkedInUrl(String(value))
    ) {
      return { valid: false, label: item.label || 'LinkedIn Link' };
    }
  }
  return { valid: true };
}
